export default "__VITE_ASSET__DTCa2BCQ__"